import gql from 'graphql-tag';


const TaskFragment = gql`fragment TaskFragment on TodoType {
  id
  title
  status
  postponedUntil
  recurring{
    id
    isEnabled
    interval
    nextOccurrence
    lastTimeOfChange
  }
  lastTimeOfChange
  manualSortOrder
}`;

export default TaskFragment;
